import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { Product } from '@lobos/library';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-product-header',
  templateUrl: './product-header.component.html',
  styleUrls: ['./product-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ProductHeaderComponent {
  @Input() product!: Product;
  open = false;
}
